const processRow = function (row: any[]) {
  let finalVal = ''
  for (let j = 0; j < row.length; j++) {
    let innerValue = row[j] == null ? '' : row[j].toString()
    if (row[j] instanceof Date) {
      innerValue = row[j].toLocaleString()
    }
    if (typeof row[j] === 'object') {
      innerValue = JSON.stringify(row[j])
    }
    let result = innerValue.replace(/"/g, '""')
    if (result.search(/("|,|\n)/g) >= 0) {
      result = '"' + result + '"'
    }
    if (j > 0) {
      finalVal += ','
    }
    finalVal += result
  }
  return finalVal + '\n'
}

/**
 * Converts an array of objects to a csv download.
 * @param headers string array of headers
 * @param data array of data columns
 * @returns a csv string you can download
 */
export function convertToCSVstring<T extends { [K in keyof T]: string | number | symbol | null | undefined }>(
  headers: Array<keyof T>,
  data: T[]
): string {
  let str: string = processRow(headers)
  data.forEach((arr) => {
    const rowValues = headers.map((header) => arr[header])
    const text = processRow(rowValues)
    str += text
  })

  return str
}

export const downloadContent = (content: string, fileName: string) => {
  const element = document.createElement('a')
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content))
  element.setAttribute('download', fileName)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
